var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 74,
    viewBox: "0 0 62 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 70.8299C15.536 70.8299 3 62.0741 3 47.0895V46.792C3 39.6068 7.16132 33.8606 13.5 30.132C19.5635 26.5652 23.1479 19.9926 22.25 13.1745L20.5 3L26.989 5.69485C38.6769 10.5486 48.4132 18.9623 54.722 29.6605C57.5255 34.4144 59 39.795 59 45.2703V47.0895C59 52.3883 57.4324 56.9085 54.722 60.5378",
    stroke: "url(#paint0_linear_1418_4625)",
    strokeWidth: 5.30556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0005 70.8299C25.2013 70.8299 20.5005 65.9709 20.5005 59.9771C20.5005 55.2263 24.0572 51.4268 27.1848 47.9451L31.0005 43.6979L34.8162 47.9451C37.9438 51.4268 41.5005 55.2263 41.5005 59.9771C41.5005 65.9709 36.7996 70.8299 31.0005 70.8299Z",
    stroke: "url(#paint1_linear_1418_4625)",
    strokeWidth: 5.30556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1418_4625",
    x1: 31,
    y1: 3,
    x2: 31,
    y2: 70.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF48F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1418_4625",
    x1: 31.0005,
    y1: 43.6979,
    x2: 31.0005,
    y2: 70.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF48F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.37604ac7a1bc25864148c894750077a1.svg";
export { ForwardRef as ReactComponent };